const RootPath = window.g.baseUrl
const apis = {
  getPalletList: RootPath + 'plugin/external/Pallet/GetPalletList',
  delPalletModelList: RootPath + 'plugin/external/Pallet/DelPalletModelList',
  savePallet: RootPath + 'plugin/external/Pallet/SavePallet',
  getDepartmentList: RootPath + 'plugin/external/Pallet/GetDepartmentList',
  getOutStoreList: RootPath + 'plugin/external/Pallet/GetOutStoreList',
  getPalletForm: RootPath + 'plugin/external/Pallet/GetPalletForm',
  getPhaseCount: RootPath + 'plugin/external/Pallet/GetPhaseCount',
  getScanInRecord: RootPath + 'plugin/external/Pallet/GetScanInRecord',
  getScanOutRecord: RootPath + 'plugin/external/Pallet/GetScanOutRecord',
  getDailySummaryList: RootPath + 'plugin/external/Pallet/GetDailySummaryList',
  getAllSummaryList: RootPath + 'plugin/external/Pallet/GetAllSummaryList',
  delExternalSample: RootPath + 'plugin/external/Pallet/DelExternalSample',
  exportOutNoteList: RootPath + 'plugin/plate/packagenote/ExportOutNoteList',
  getPageList: RootPath + 'plugin/external/Pallet/GetPageList'
}

export default apis
